module.exports = __webpack_public_path__ + "img/area.dc1fd16b.png";